AgrimarketControllers.controller('siteUnavailableController', ['$scope', '$rootScope', 'configurationFactory','$filter',
function ($scope, $rootScope, configurationFactory, $filter) {
    $rootScope.skin = configurationFactory.Skin;
    if (configurationFactory.Skin.skinMultiple) {
        var skin = $filter('filter')(configurationFactory.Skin.skinMultiple, { urlLogin: window.location.href }, true)[0];
        if (skin)
            $rootScope.skin = skin;
    }
}]);